import * as React from "react";

const SvgGettyGLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.82074 4.01591C9.82074 5.0868 8.94731 5.93041 7.86624 5.93041C6.65099 5.93041 5.80338 5.0868 5.80338 4.01591C5.80338 2.95048 6.65099 2.10068 7.86624 2.10068C8.94731 2.10068 9.82074 2.95048 9.82074 4.01591ZM2.77799 12.4786C2.69205 12.7502 2.65535 13.0349 2.66963 13.3193C2.75945 15.1397 4.76558 16 7.9746 16C11.7789 16 13.4996 14.2229 13.4996 12.5775C13.4996 7.95509 5.6532 10.4932 5.6532 8.6249C5.6532 7.95509 6.64009 7.91037 7.87715 7.91037C10.8702 7.91037 12.38 6.35913 12.38 4.17373C12.38 3.28284 12.1061 2.61485 11.74 2.12432C12.1745 1.85596 12.9116 1.85596 13.5756 1.85596V0.00400404C12.2207 -0.0421767 11.3247 0.311997 10.7764 1.02071C10.0429 0.401449 8.84804 0.00400404 7.83824 0.00400404C4.73758 0.00400404 3.13217 1.99814 3.13217 4.02427C3.13217 5.42606 3.91178 6.31259 4.8994 7.09075C4.36777 7.24275 3.03835 8.08782 3.03835 9.19797C3.03835 10.7034 5.13248 11.2845 7.75351 11.4405C9.88183 11.5703 10.9207 12.0899 10.9207 12.8892C10.9207 13.4077 10.2625 14.1299 8.43132 14.1786C5.46339 14.2582 5.14121 13.4066 5.33102 12.5259L2.77799 12.4786Z"
      fill="white"
    />
  </svg>
);
export default SvgGettyGLogo;
